import { type FC, type PropsWithChildren } from 'react'

/**
 * Tab text (to be used in Tabs.Cell)
 */
export const TabsTextCell: FC<PropsWithChildren> = ({ children }) => {
  return <span className="tabs-textcell">{children}</span>
}

TabsTextCell.displayName = 'TabsTextCell'
